import css from "./CarrosselEstrutura.module.css"
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination,Navigation} from "swiper/modules";


function CarrosselEstrutura() {
    return (
        <div className={`${css.carrosselEstrutura} d-none d-lg-block`}>
            <Swiper className={"h-100 px-5"}
                // install Swiper modules
                    modules={[ Pagination,Navigation]}
                    spaceBetween={20}
                    slidesPerView={3}
                    navigation
                    pagination={{ clickable: true }}
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log('slide change')}

            >
                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/cr1.webp" alt="" />
                </SwiperSlide>

                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/cr2.webp" alt="" />
                </SwiperSlide>

                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/cr3.webp" alt="" />
                </SwiperSlide>

                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/cr4.webp" alt="" />
                </SwiperSlide>

                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/PAC.webp" alt="" />
                </SwiperSlide>

                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/REAB.webp" alt="" />
                </SwiperSlide>

                <SwiperSlide className="d-flex flex-column justify-content-center align-items-center h-100">
                    <img className={`object-fit-cover ${css.slidercontato}`} src="/zumbido.webp" alt="" />
                </SwiperSlide>

                ...
            </Swiper>
        </div>
    )
}
export default CarrosselEstrutura;